

$(document).ready(function() {

    // AOS

    AOS.init(
        {
            'once': true,
            'startEvent': 'load',
        }
    );

    // search

    search = $('.search-line')

    $('.search-open').on('click', function () {
        search.toggleClass('active')
        search.show()
    })

    $('.close-search').on('click', function () {
        search.toggleClass('active')
        search.show()
    })

    // burger

    $('.navbar-toggler').on('click', function () {
        $('.navbar-menu').toggleClass('show');
        $('.nav-icon').toggleClass('open');
        $('.nav-bg').toggleClass('show-bg');
    });
    $('.nav-bg').on('click', function () {
        $(this).removeClass('show-bg');
        $('.navbar-menu').removeClass('show');
        $('.nav-icon').removeClass('open');
    });

    // swiper

    new Swiper(".products-swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        // autoplay: {
        //     delay: 6000,
        //     disableOnInteraction: false,
        //     pauseOnMouseEnter: false,
        // },
        navigation: {
            nextEl: '.next-prod',
            prevEl: '.prev-prod'
        },
        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
        }
    });

    // scrollUp

    $(window).scroll(function() {
        if ($(this).scrollTop() > 525) {
            $("#scrollUp").fadeIn();
        } else {
            $("#scrollUp").fadeOut();
        }
    });

    $("#scrollUp").click(function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    });
});